import type { RidesMatchQuery, RidesSecurityExpectedQuery } from '@actschurch/ccms-sdk';

/** React Query keys for the Rides portal — one place so invalidation is predictable. */
export const ridesKeys = {
  all: ['rides'] as const,
  lookups: ['rides', 'lookups'] as const,
  publicSettings: ['rides', 'public-settings'] as const,
  events: (from?: string | null, to?: string | null) => ['rides', 'events', from ?? '', to ?? ''] as const,
  me: {
    all: ['rides', 'me'] as const,
    summary: ['rides', 'me', 'summary'] as const,
    profile: ['rides', 'me', 'profile'] as const,
    driver: ['rides', 'me', 'driver'] as const,
    verification: ['rides', 'me', 'verification'] as const,
    consents: ['rides', 'me', 'consents'] as const,
    /** GET me/documents (254g). View LINKS are never cached — fetched on demand only. */
    documents: ['rides', 'me', 'documents'] as const,
  },
  availability: {
    all: ['rides', 'availability'] as const,
    mine: ['rides', 'availability', 'mine'] as const,
    byId: (id: number) => ['rides', 'availability', id] as const,
  },
  matches: (q: RidesMatchQuery) => ['rides', 'matches', q] as const,
  bookings: {
    all: ['rides', 'bookings'] as const,
    mine: ['rides', 'bookings', 'mine'] as const,
    byId: (id: number) => ['rides', 'bookings', id] as const,
  },
  security: {
    expected: (q: RidesSecurityExpectedQuery) => ['rides', 'security', 'expected', q] as const,
    documents: (userId: string) => ['rides', 'security', 'documents', userId] as const,
  },
};

export const memberKeys = {
  me: ['members', 'me'] as const,
};

/** The CCMS account (UserManagement `users/me`) — carries the profile photo (`avatar`). */
export const accountKeys = {
  me: ['users', 'me'] as const,
};

/** Ride-day pages poll on this interval as a fallback to push. */
export const RIDE_DAY_POLL_MS = 30_000;
